/* istanbul ignore file */
import 'core-js'
import ReactDOM from 'react-dom/client'
import { Provider } from 'react-redux'
import { PersistGate } from 'redux-persist/integration/react'
import { ThemeProvider } from '@emotion/react'
import { BUGSNAG_API_KEY } from './config'
import packageJson from '../package.json'
import { getEnvironmentName } from 'utils/environmentUtil'
import theme from './theme'
import App from 'App'

import AnalyticsGateway from 'cec-commons-util-analytics-gateway'
import { BrowserRouter } from 'react-router-dom'
import store, { persistor } from 'store'
import { initializeClarity } from 'utils/clarityUtil'
import BugsnagUtil from 'utils/BugsnagUtil'

import 'styles/main.scss'
import { dpprApiGet } from 'utils/http'
import { asyncWithLDProvider } from 'launchdarkly-react-client-sdk'
import { saveConfiguration } from 'store/actions/configurationAction'
import ErrorPage from 'pages/ErrorPage'
import useAppcues from 'utils/appcuesUtil'

BugsnagUtil.initialize({
  apiKey: BUGSNAG_API_KEY,
  appVersion: packageJson.version,
  releaseStage: getEnvironmentName()
})

const ErrorBoundary = BugsnagUtil.getErrorBoundary();

(async function () {
  try {
    const { data: configData } = await dpprApiGet({ url: '/public/configuration' })

    AnalyticsGateway.initialize(configData.segmentKey)
    AnalyticsGateway.pageView()
    store.dispatch(saveConfiguration(configData))
    initializeClarity.initialize(configData.clarityKey)

    const LDProvider = await asyncWithLDProvider({ clientSideID: configData.launchDarklyKey })
    useAppcues({ id: configData.uniqueCookieId })

    ReactDOM.createRoot(document.getElementById('root')).render(
      <LDProvider>
        <ThemeProvider theme={theme}>
          <Provider store={store}>
            <PersistGate persistor={persistor}>
              <BrowserRouter>
                <ErrorBoundary>
                  <App />
                </ErrorBoundary>
              </BrowserRouter>
            </PersistGate>
          </Provider>
        </ThemeProvider>
      </LDProvider>
    )
  } catch (e) {
    BugsnagUtil.notify(e)
    ReactDOM.createRoot(document.getElementById('root')).render(
      <ErrorPage />
    )
  }
})()
